export const INVENTORY_REQUEST_STATUS_PENDING = 1
export const INVENTORY_REQUEST_STATUS_APPROVED = 2

export const inventoryRequestStatusOptions = [
  { label: 'Pending', value: 1 },
  { label: 'Approved', value: 2 },
  { label: 'In Procurement', value: 3 },
  { label: 'Issued', value: 4 },
  { label: 'Declined', value: 5 },
]

export const getInventoryRequestStatusLabel = (status: number) =>
  inventoryRequestStatusOptions.find((s) => s.value === status)?.label || '/'
